export class ConfigDB {
    static data = {
        settings: {
            layout_type: 'ltr',
            layout_class: 'compact-wrapper',
            sidebar: {
                iconType: 'stroke',
            },
            sidebar_setting: 'default-sidebar',
        },
        color: {
            primary_color: '#6f5a99',
            secondary_color: '#e24175',
            mix_background_layout: 'dark-sidebar',
        }
    };
}
export default ConfigDB;